import { PlanGate } from '@relay-towing/ui';
import { upgradePlans, type PlanRefusalDto } from '@relay-towing/api';
import { usePlan } from '../../hooks/usePlan';
import { links } from '../../lib/links';
import { openExternal } from '../../lib/nativeBridge';

/**
 * What a member sees when the server refuses something because of the plan
 * (a 403 with a PlanRefusalDto body): the call limit reached, say. The
 * server's message names the plan that allows it, and is shown as it is.
 * A member who manages the subscription also gets that plan and Upgrade;
 * everyone else is told to ask their owner.
 */
export function RefusalUpsell({
  refusal,
  onClose,
  title,
}: {
  refusal: PlanRefusalDto | null;
  onClose: () => void;
  title: string;
}) {
  const plan = usePlan();
  const plans =
    plan.canUpgrade && refusal?.upgradeTo && plan.catalogue && plan.plan
      ? upgradePlans(plan.catalogue, plan.plan.id, { plan: refusal.upgradeTo })
      : undefined;

  return (
    <PlanGate
      presentation="sheet"
      open={refusal !== null}
      onOpenChange={(open) => !open && onClose()}
      title={title}
      message={refusal?.message ?? ''}
      detail={
        plans?.length ? 'Select an upgrade and we’ll do the rest.' : undefined
      }
      canUpgrade={plan.canUpgrade}
      plans={plans}
      primaryLabel={plan.canUpgrade ? 'Upgrade' : undefined}
      onPrimary={
        plan.canUpgrade
          ? () => {
              openExternal(links.billing);
              onClose();
            }
          : undefined
      }
      dismissLabel={plan.canUpgrade ? 'No thanks' : 'Close'}
      onDismiss={onClose}
    />
  );
}
